import { useNavigate } from '@reach/router'
import { useQuery } from '@tanstack/react-query'
import { notification } from 'antd'
import { AxiosError } from 'axios'

import { axiosInstance } from '../../../axios/axiosInstance'

export const key = ['GET_GOOGLE_API_KEY']

export const useGetGoogleApiKey = (code: string) => {
  const navigate = useNavigate()
  return useQuery(
    [key],
    async () => {
      const { data } = await axiosInstance.get(
        `/api/auth/member/google-login?code=${code}`,
      )
      return data.token
    },
    {
      retry: 0,
      enabled: !!code,
      /**
       * An authorisation code can be exchanged once, so every automatic refetch
       * of it is guaranteed to fail. The query client sets
       * refetchOnWindowFocus: true for the whole app, and this query had no
       * staleTime, so simply focusing the window re-sent a code Google had
       * already issued a token for — a 422 that surfaced as the onError below,
       * navigating away and reporting "User does not exist." over a sign-in that
       * had just succeeded.
       *
       * Deliberately not staleTime/cacheTime: the query key does not include the
       * code, so caching the result would serve a previous login's token to the
       * next one.
       */
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      onError: (error: AxiosError) => {
        if (error) {
          navigate('/', { replace: true })
          notification.error({ message: 'User does not exist.' })
        }
      },
    },
  )
}
